import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49;

import { DATE_CONSIDERATIONS, PlatformType, WEB_LOCATION_SEARCH_TAB_NAMES, constructRestaurantDetailsUrl, getEnvProps } from "@dp/common";
import DPServices from "@dp/services";
import i18next from "i18next";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { persist } from "mobx-persist";
import moment from "moment-timezone";
import { nearbyRestaurants } from "../../mockdata/locations";
import BrandRules from "../../utils/BrandRules";
import { _getFormattedDate } from "../../utils/common";
export var ORDER_TYPE;

(function (ORDER_TYPE) {
  ORDER_TYPE[ORDER_TYPE["TOGO_PICKUP"] = 0] = "TOGO_PICKUP";
  ORDER_TYPE[ORDER_TYPE["GIFT_CARD"] = 1] = "GIFT_CARD";
  ORDER_TYPE[ORDER_TYPE["CATERING_DELIVERY"] = 2] = "CATERING_DELIVERY";
  ORDER_TYPE[ORDER_TYPE["CATERING_PICKUP"] = 3] = "CATERING_PICKUP";
  ORDER_TYPE[ORDER_TYPE["ORDER_AHEAD"] = 5] = "ORDER_AHEAD";
  ORDER_TYPE[ORDER_TYPE["TOGO_DELIVERY"] = 6] = "TOGO_DELIVERY";
})(ORDER_TYPE || (ORDER_TYPE = {}));

var OrderSettingsModel = (_dec = persist("object"), (_class = /*#__PURE__*/function () {
  function OrderSettingsModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, OrderSettingsModel);

    _initializerDefineProperty(this, "_currentOrderType", _descriptor, this);

    _initializerDefineProperty(this, "_showRestaurantSearchModal", _descriptor2, this);

    _initializerDefineProperty(this, "_showOrderSettingsConfirmationModal", _descriptor3, this);

    _initializerDefineProperty(this, "_showTimeSidebar", _descriptor4, this);

    _initializerDefineProperty(this, "_isLocationSettingVisible", _descriptor5, this);

    _initializerDefineProperty(this, "_isDeliveryMessageVisible", _descriptor6, this);

    _initializerDefineProperty(this, "_locationSearchString", _descriptor7, this);

    _initializerDefineProperty(this, "_locationSearchLabel", _descriptor8, this);

    _initializerDefineProperty(this, "_addressSuggestions", _descriptor9, this);

    _initializerDefineProperty(this, "_restaurantSearchResults", _descriptor10, this);

    _initializerDefineProperty(this, "_selectedLocationState", _descriptor11, this);

    _initializerDefineProperty(this, "_selectedLocationStateForPreferredFlow", _descriptor12, this);

    _initializerDefineProperty(this, "_restaurantDetail", _descriptor13, this);

    _initializerDefineProperty(this, "_locationSearchMode", _descriptor14, this);

    _initializerDefineProperty(this, "_showMyLocations", _descriptor15, this);

    _initializerDefineProperty(this, "_activeLocationListIndex", _descriptor16, this);

    _initializerDefineProperty(this, "_showLocationSettings", _descriptor17, this);

    _initializerDefineProperty(this, "_togoThresholdAmount", _descriptor18, this);

    _initializerDefineProperty(this, "_restPhoneNumber", _descriptor19, this);

    _initializerDefineProperty(this, "_showPickupConfirmModal", _descriptor20, this);

    _initializerDefineProperty(this, "_isLocationsListLoading", _descriptor21, this);

    _initializerDefineProperty(this, "_isSearchResultsLoading", _descriptor22, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor23, this);

    _initializerDefineProperty(this, "_confirmTimeLocationLoader", _descriptor24, this);

    _initializerDefineProperty(this, "_locationTimeConfirmed", _descriptor25, this);

    _initializerDefineProperty(this, "_resturantSelctedForChange", _descriptor26, this);

    _initializerDefineProperty(this, "_deliveryToPickupConfirmationLoader", _descriptor27, this);

    _initializerDefineProperty(this, "_orderTypeValue", _descriptor28, this);

    _initializerDefineProperty(this, "_savedRestaurants", _descriptor29, this);

    _initializerDefineProperty(this, "_mylocationLoading", _descriptor30, this);

    _initializerDefineProperty(this, "_deliveryOrderPartySize", _descriptor31, this);

    _initializerDefineProperty(this, "_pickupDatetimeselected", _descriptor32, this);

    _initializerDefineProperty(this, "_isMapVisibleOnMobileSearch", _descriptor33, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor34, this);

    _initializerDefineProperty(this, "_filterTogo", _descriptor35, this);

    _initializerDefineProperty(this, "_savedLocationSearchEntries", _descriptor36, this);

    _initializerDefineProperty(this, "_isFromLocationSearchPage", _descriptor37, this);

    _initializerDefineProperty(this, "_locationSearchTab", _descriptor38, this);

    _initializerDefineProperty(this, "_nearbyRestaurantRefs", _descriptor39, this);

    _initializerDefineProperty(this, "_initialDimensionOfWebMap", _descriptor40, this);

    _initializerDefineProperty(this, "_openHoursDisplayOrder", _descriptor41, this);

    _initializerDefineProperty(this, "_isScrollEnableOnLocationPinClick", _descriptor42, this);

    _initializerDefineProperty(this, "_showYouAreHere", _descriptor43, this);

    _initializerDefineProperty(this, "_showUserCurrentLocation", _descriptor44, this);

    _initializerDefineProperty(this, "_appShouldShowInternationalLocations", _descriptor45, this);

    _defineProperty(this, "platformUtil", void 0);

    _initializerDefineProperty(this, "locationSearchedTerm", _descriptor46, this);

    _defineProperty(this, "setSavedRestaurants", function (data) {
      runInAction(function () {
        _this._savedRestaurants = data;
      });
    });

    _defineProperty(this, "setSavedLocationSearchEntries", function (data) {
      runInAction(function () {
        _this._savedLocationSearchEntries = data;
      });
    });

    _defineProperty(this, "setLocationSettingVisibility", function () {
      runInAction(function () {
        _this._isLocationSettingVisible = !_this._isLocationSettingVisible;
      });
    });

    _defineProperty(this, "setDeliveryMessageVisibility", function () {
      runInAction(function () {
        _this._isDeliveryMessageVisible = !_this._isDeliveryMessageVisible;
      });
    });

    _initializerDefineProperty(this, "confirmOrderSettings", _descriptor47, this);

    _initializerDefineProperty(this, "cancelOrderSettingsConfirmation", _descriptor48, this);

    _initializerDefineProperty(this, "setShowLocationSettings", _descriptor49, this);

    _defineProperty(this, "isRestaurantClosed", function (restaurantTimeZone, closedDays, addDays) {
      var _moment2, _moment2$tz;

      var isRestaurantHoliday = false;
      var closedDaysLength = closedDays === null || closedDays === void 0 ? void 0 : closedDays.length;
      var formattedClosedDays = closedDays === null || closedDays === void 0 ? void 0 : closedDays.map(function (day) {
        var _moment;

        return (_moment = moment(day, "MM/DD/YYYY")) === null || _moment === void 0 ? void 0 : _moment.format(DATE_CONSIDERATIONS.DATE_FORMAT);
      });
      var userCurrentDayInTZ = moment((_moment2 = moment()) === null || _moment2 === void 0 ? void 0 : (_moment2$tz = _moment2.tz(restaurantTimeZone)) === null || _moment2$tz === void 0 ? void 0 : _moment2$tz.format(DATE_CONSIDERATIONS.DATE_FORMAT)).add(addDays, "days");

      for (var index = 0; index < closedDaysLength; index++) {
        var closedDay = moment(formattedClosedDays[index]);

        if (closedDay.valueOf() === userCurrentDayInTZ.valueOf()) {
          isRestaurantHoliday = true;
          break;
        }
      }

      return isRestaurantHoliday;
    });

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(OrderSettingsModel, [{
    key: "setPickupDatetimeselected",
    value: function setPickupDatetimeselected(selected) {
      var _this2 = this;

      runInAction(function () {
        _this2._pickupDatetimeselected = selected;
      });
    }
  }, {
    key: "setDeliveryOrderPartySize",
    value: function setDeliveryOrderPartySize(size) {
      var _this3 = this;

      runInAction(function () {
        _this3._deliveryOrderPartySize = size;
      });
    }
  }, {
    key: "toggleMyLocationLoading",
    value: function toggleMyLocationLoading(show) {
      var _this4 = this;

      runInAction(function () {
        _this4._mylocationLoading = show;
      });
    }
  }, {
    key: "decodeSavedResturant",
    value: function decodeSavedResturant(_resturant) {
      if (!_resturant) return [];
      return _resturant.map(function (_r) {
        var _r$restaurantNumber, _r$contactDetail, _r$contactDetail$addr, _r$contactDetail2, _r$contactDetail2$add, _r$contactDetail3, _r$contactDetail3$add, _r$contactDetail4, _r$contactDetail4$add, _r$contactDetail5, _r$contactDetail5$add;

        return {
          restaurantId: _r.atgRestaurantId,
          restaurantNumber: (_r$restaurantNumber = _r.restaurantNumber) === null || _r$restaurantNumber === void 0 ? void 0 : _r$restaurantNumber.toString(),
          isOnlineTogoSupported: _r.features.onlineTogoEnabled,
          AddressOne: (_r$contactDetail = _r.contactDetail) === null || _r$contactDetail === void 0 ? void 0 : (_r$contactDetail$addr = _r$contactDetail.address) === null || _r$contactDetail$addr === void 0 ? void 0 : _r$contactDetail$addr.street1,
          AddressTwo: (_r$contactDetail2 = _r.contactDetail) === null || _r$contactDetail2 === void 0 ? void 0 : (_r$contactDetail2$add = _r$contactDetail2.address) === null || _r$contactDetail2$add === void 0 ? void 0 : _r$contactDetail2$add.street2,
          state: (_r$contactDetail3 = _r.contactDetail) === null || _r$contactDetail3 === void 0 ? void 0 : (_r$contactDetail3$add = _r$contactDetail3.address) === null || _r$contactDetail3$add === void 0 ? void 0 : _r$contactDetail3$add.stateCode,
          zip: (_r$contactDetail4 = _r.contactDetail) === null || _r$contactDetail4 === void 0 ? void 0 : (_r$contactDetail4$add = _r$contactDetail4.address) === null || _r$contactDetail4$add === void 0 ? void 0 : _r$contactDetail4$add.zipCode,
          restaurantName: _r.restaurantName,
          city: (_r$contactDetail5 = _r.contactDetail) === null || _r$contactDetail5 === void 0 ? void 0 : (_r$contactDetail5$add = _r$contactDetail5.address) === null || _r$contactDetail5$add === void 0 ? void 0 : _r$contactDetail5$add.city
        };
      });
    }
  }, {
    key: "setResturantSelectedForChangeNumber",
    value: function setResturantSelectedForChangeNumber(num) {
      var _this5 = this;

      runInAction(function () {
        _this5._resturantSelctedForChange = num;
      });
    }
  }, {
    key: "setOrderTypeValue",
    value: function setOrderTypeValue(_orderType) {
      this._orderTypeValue = _orderType;
    }
  }, {
    key: "setLocationTimeConfirmData",
    value: function setLocationTimeConfirmData(confirmed) {
      var _this6 = this;

      runInAction(function () {
        _this6._locationTimeConfirmed = confirmed;
      });
    } // location time is not required for both delivery and order ahead

  }, {
    key: "toggleDeliveryToPickupConfirmationLoader",
    value: function toggleDeliveryToPickupConfirmationLoader(show) {
      var _this7 = this;

      runInAction(function () {
        _this7._deliveryToPickupConfirmationLoader = show;
      });
    }
  }, {
    key: "toggleConfirmTimeLocationLoader",
    value: function toggleConfirmTimeLocationLoader(show) {
      var _this8 = this;

      runInAction(function () {
        _this8._confirmTimeLocationLoader = show;
      });
    }
  }, {
    key: "setPickupConfirmModalToggle",
    value: function setPickupConfirmModalToggle(toggle) {
      var _this9 = this;

      runInAction(function () {
        _this9._showPickupConfirmModal = toggle;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this10 = this;

      runInAction(function () {
        _this10._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setRestaurantDetailData",
    value: function setRestaurantDetailData(_restaurantDetail) {
      var _this11 = this;

      runInAction(function () {
        _this11._restaurantDetail = _restaurantDetail;
      });
    }
  }, {
    key: "setIsSearchResultLoading",
    value: function setIsSearchResultLoading(state) {
      var _this12 = this;

      runInAction(function () {
        _this12._isSearchResultsLoading = state;
      });
    }
  }, {
    key: "setRestaurantSearchResultsData",
    value: function setRestaurantSearchResultsData(_searchResults) {
      var _this13 = this;

      runInAction(function () {
        _this13._restaurantSearchResults = _searchResults;
      });
    }
  }, {
    key: "setIsLocationsListLoading",
    value: function setIsLocationsListLoading(bool) {
      this._isLocationsListLoading = bool;
    }
  }, {
    key: "setIsMapVisibleOnMobileSearch",
    value: function setIsMapVisibleOnMobileSearch(bool) {
      this._isMapVisibleOnMobileSearch = bool;
    }
  }, {
    key: "setRestPhoneNumber",
    value: function setRestPhoneNumber(number) {
      this._restPhoneNumber = number;
    }
  }, {
    key: "formatPhoneNumber",
    value: function formatPhoneNumber(phoneNumberString) {
      var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }

      return "";
    }
  }, {
    key: "filterRestaurants",
    value: function filterRestaurants(restaurant, isFromLocationSearchPage) {
      var _restaurant$features;

      if (isFromLocationSearchPage) {
        return true;
      } // For location popup don't show Franchise locations (restaurant?.enableLocationDetail: false)


      if (!isFromLocationSearchPage && restaurant !== null && restaurant !== void 0 && (_restaurant$features = restaurant.features) !== null && _restaurant$features !== void 0 && _restaurant$features.locationDetailEnabled) {
        return true;
      }

      return false;
    }
  }, {
    key: "setAddressSuggestionsData",
    value: function setAddressSuggestionsData(_suggestions) {
      var _this14 = this;

      runInAction(function () {
        _this14._addressSuggestions = _suggestions;
      });
    }
  }, {
    key: "setSelectedLocationState",
    value: function setSelectedLocationState(_text) {
      var _this15 = this;

      runInAction(function () {
        _this15._selectedLocationState = _text;
      });
    }
  }, {
    key: "setSelectedLocationStateForPreferredFlow",
    value: function setSelectedLocationStateForPreferredFlow(_text) {
      var _this16 = this;

      runInAction(function () {
        _this16._selectedLocationStateForPreferredFlow = _text;
      });
    }
  }, {
    key: "clearAddressSuggestionsData",
    value: function clearAddressSuggestionsData() {
      var _this17 = this;

      runInAction(function () {
        _this17._addressSuggestions = null;
      });
    }
  }, {
    key: "closeSearchMode",
    value: function closeSearchMode() {
      var _this18 = this;

      runInAction(function () {
        _this18._locationSearchMode = "RESTAURANT";
      });
    }
  }, {
    key: "setShowMyLocations",
    value: function setShowMyLocations(bool) {
      this._showMyLocations = bool;
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this19 = this;

      runInAction(function () {
        _this19._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setFilterTogo",
    value: function setFilterTogo(_filterTogo) {
      var _this20 = this;

      runInAction(function () {
        _this20._filterTogo = _filterTogo;
      });
    }
  }, {
    key: "setLocationSearchTab",
    value: function setLocationSearchTab(tab) {
      this._activeLocationListIndex = 0;
      this._locationSearchTab = tab;
    }
  }, {
    key: "getrestaurantCurrentWeekClosedStatus",
    value: function getrestaurantCurrentWeekClosedStatus(timezone, _closedDays) {
      var restaurantClosedStatusArr = [];

      for (var i = 0; i < 7; i++) {
        restaurantClosedStatusArr.push(this.isRestaurantClosed(timezone, _closedDays, i));
      }

      return restaurantClosedStatusArr;
    }
  }, {
    key: "setNearbyRestaurantRefs",
    value: function setNearbyRestaurantRefs(ref) {
      this._nearbyRestaurantRefs.push(ref);
    }
  }, {
    key: "setNearbyRestaurantRefsToEmpty",
    value: function setNearbyRestaurantRefsToEmpty() {
      this._nearbyRestaurantRefs = [];
    }
  }, {
    key: "setInitialDimensionOfWebMap",
    value: function setInitialDimensionOfWebMap(initialDimension) {
      var _this21 = this;

      runInAction(function () {
        _this21._initialDimensionOfWebMap = initialDimension;
      });
    }
  }, {
    key: "setIsScrollEnableOnLocationPinClick",
    value: function setIsScrollEnableOnLocationPinClick(val) {
      var _this22 = this;

      runInAction(function () {
        _this22._isScrollEnableOnLocationPinClick = val;
      });
    }
  }, {
    key: "happyHourLink",
    get: function get() {
      var _this$_restaurantDeta, _this$_restaurantDeta2, _this$_restaurantDeta3, _this$_restaurantDeta4, _this$_restaurantDeta5, _this$_restaurantDeta6, _this$_restaurantDeta7, _this$_restaurantDeta8, _this$_restaurantDeta9;

      var happyHourSource = this.platformUtil.PLATFORM_TYPE === "APP" ? "?happyhoursource=app" : "";

      if ((_this$_restaurantDeta = this._restaurantDetail) !== null && _this$_restaurantDeta !== void 0 && (_this$_restaurantDeta2 = _this$_restaurantDeta.features) !== null && _this$_restaurantDeta2 !== void 0 && _this$_restaurantDeta2.showHappyHour && (_this$_restaurantDeta3 = this._restaurantDetail) !== null && _this$_restaurantDeta3 !== void 0 && (_this$_restaurantDeta4 = _this$_restaurantDeta3.contactDetail) !== null && _this$_restaurantDeta4 !== void 0 && (_this$_restaurantDeta5 = _this$_restaurantDeta4.address) !== null && _this$_restaurantDeta5 !== void 0 && _this$_restaurantDeta5.stateCode && (_this$_restaurantDeta6 = this._restaurantDetail) !== null && _this$_restaurantDeta6 !== void 0 && (_this$_restaurantDeta7 = _this$_restaurantDeta6.contactDetail) !== null && _this$_restaurantDeta7 !== void 0 && (_this$_restaurantDeta8 = _this$_restaurantDeta7.address) !== null && _this$_restaurantDeta8 !== void 0 && _this$_restaurantDeta8.city && (_this$_restaurantDeta9 = this._restaurantDetail) !== null && _this$_restaurantDeta9 !== void 0 && _this$_restaurantDeta9.restaurantNumber) {
        var _this$_restaurantDeta10, _this$_restaurantDeta11;

        return "/happy-hour/".concat((_this$_restaurantDeta10 = this._restaurantDetail.contactDetail) === null || _this$_restaurantDeta10 === void 0 ? void 0 : _this$_restaurantDeta10.address.stateCode.toLowerCase(), "/").concat((_this$_restaurantDeta11 = this._restaurantDetail.contactDetail) === null || _this$_restaurantDeta11 === void 0 ? void 0 : _this$_restaurantDeta11.address.city.toLowerCase().split(" ").join("-"), "-restaurant/").concat(this._restaurantDetail.restaurantNumber).concat(happyHourSource);
      } else {
        return "/menu-listing/happy-hour".concat(happyHourSource);
      }
    }
  }, {
    key: "headerNavigation",
    get: function get() {
      try {
        var _this$_appAttributes, _this$_appAttributes$, _data$replace;

        var data = (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$["headerNavigation"];
        var parsedData = JSON.parse(data === null || data === void 0 ? void 0 : (_data$replace = data.replace(/([a-zA-Z0-9]+?):(?![\/\/])/gm, '"$1":')) === null || _data$replace === void 0 ? void 0 : _data$replace.replace(/'/g, '"'));
        var headerNavigation = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.headerNavigation) === "true" ? true : false;
        var headerNavigationLabel = parsedData === null || parsedData === void 0 ? void 0 : parsedData.headerNavigationLabel;
        var headerNavigationLink = parsedData === null || parsedData === void 0 ? void 0 : parsedData.headerNavigationLink;
        var headerNavigationOpenInNewTab = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.headerNavigationOpenInNewTab) === "true" ? true : false;
        return {
          headerNavigation: headerNavigation,
          headerNavigationLabel: headerNavigationLabel,
          headerNavigationLink: headerNavigationLink,
          headerNavigationOpenInNewTab: headerNavigationOpenInNewTab
        };
      } catch (_unused) {
        return {};
      }
    }
  }, {
    key: "pickupDateTimeSelected",
    get: function get() {
      return !!this._pickupDatetimeselected;
    }
  }, {
    key: "mylocationLoading",
    get: function get() {
      return !!this._mylocationLoading;
    }
  }, {
    key: "savedLocationSearchEntries",
    get: function get() {
      if (this._savedLocationSearchEntries && this._savedLocationSearchEntries.length) {
        return this._savedLocationSearchEntries;
      } else {
        return [];
      }
    }
  }, {
    key: "searchedLocationDetail",
    get: function get() {
      return this.locationSearchedTerm;
    },
    set: function set(data) {
      var _this23 = this;

      runInAction(function () {
        _this23.locationSearchedTerm = data;
      });
    }
  }, {
    key: "savedResturants",
    get: function get() {
      return this.decodeSavedResturant(this._savedRestaurants);
    }
  }, {
    key: "orderType",
    get: function get() {
      var _this$_sessionDetails, _this$_sessionDetails2;

      return this._orderTypeValue || ((_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.orderContext) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.orderTypeValue);
    }
  }, {
    key: "resturantSelectedForChangeNumber",
    get: function get() {
      return this._resturantSelctedForChange;
    }
  }, {
    key: "locationTimeConfirmed",
    get: function get() {
      if (this.orderType === ORDER_TYPE.CATERING_DELIVERY || this.orderType === ORDER_TYPE.TOGO_DELIVERY) {
        return true;
      } else {
        var isConfirmationRequired = this.orderType !== ORDER_TYPE.CATERING_DELIVERY && this.orderType !== ORDER_TYPE.ORDER_AHEAD;
        return isConfirmationRequired ? !!this._locationTimeConfirmed : true;
      }
    }
  }, {
    key: "deliveryToPickupConfirmationLoader",
    get: function get() {
      return !!this._deliveryToPickupConfirmationLoader;
    }
  }, {
    key: "confirmTimeLocationLoader",
    get: function get() {
      return !!this._confirmTimeLocationLoader;
    }
  }, {
    key: "showPickupConfirmModal",
    get: function get() {
      return !!this._showPickupConfirmModal;
    }
  }, {
    key: "isSearchResultsLoading",
    get: function get() {
      return this._isSearchResultsLoading;
    }
  }, {
    key: "isLocationsListLoading",
    get: function get() {
      return this._isLocationsListLoading;
    }
  }, {
    key: "isMapVisibleOnMobileSearch",
    get: function get() {
      return this._isMapVisibleOnMobileSearch;
    }
  }, {
    key: "togoThresholdAmount",
    get: function get() {
      if (this.orderType === ORDER_TYPE.TOGO_PICKUP) {
        var _this$_sessionDetails3;

        return (_this$_sessionDetails3 = this._sessionDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : _this$_sessionDetails3.orderAmountThreshold;
      } else if (this.orderType === ORDER_TYPE.CATERING_PICKUP) {
        var _this$_sessionDetails4;

        return (_this$_sessionDetails4 = this._sessionDetails) === null || _this$_sessionDetails4 === void 0 ? void 0 : _this$_sessionDetails4.cateringPickupOrderAmountThreshold;
      } else if (this.orderType === ORDER_TYPE.CATERING_DELIVERY) {
        var _this$currentRestaura;

        return (_this$currentRestaura = this.currentRestaurant) === null || _this$currentRestaura === void 0 ? void 0 : _this$currentRestaura.catDeliveryMaxOrderAmount;
      } else if (this.orderType === ORDER_TYPE.ORDER_AHEAD) {
        var _this$_sessionDetails5;

        return (_this$_sessionDetails5 = this._sessionDetails) === null || _this$_sessionDetails5 === void 0 ? void 0 : _this$_sessionDetails5.orderAheadOrderAmountThreshold;
      }

      return null;
    }
  }, {
    key: "resturantPhoneNumberWithCountryCode",
    get: function get() {
      var _this$currentRestaura2, _this$currentRestaura3, _this$currentRestaura4, _this$currentRestaura5;

      return ((_this$currentRestaura2 = this.currentRestaurant) === null || _this$currentRestaura2 === void 0 ? void 0 : (_this$currentRestaura3 = _this$currentRestaura2.contactDetail) === null || _this$currentRestaura3 === void 0 ? void 0 : (_this$currentRestaura4 = _this$currentRestaura3.phoneDetail) === null || _this$currentRestaura4 === void 0 ? void 0 : (_this$currentRestaura5 = _this$currentRestaura4.find(function (phone) {
        return (phone === null || phone === void 0 ? void 0 : phone.type) === "Primary";
      })) === null || _this$currentRestaura5 === void 0 ? void 0 : _this$currentRestaura5.phoneNumber) || "";
    }
  }, {
    key: "restPhoneNumber",
    get: function get() {
      return this._restPhoneNumber;
    }
  }, {
    key: "showCartMessage",
    get: function get() {
      if (this.orderType === ORDER_TYPE.TOGO_PICKUP || this.orderType === ORDER_TYPE.CATERING_PICKUP || this.orderType === ORDER_TYPE.CATERING_DELIVERY || this.orderType === ORDER_TYPE.ORDER_AHEAD) {
        return true;
      }

      return false;
    }
  }, {
    key: "restaurantSearchResults",
    get: function get() {
      var _this$_restaurantSear,
          _this24 = this;

      return (_this$_restaurantSear = this._restaurantSearchResults) === null || _this$_restaurantSear === void 0 ? void 0 : _this$_restaurantSear.filter(function (restaurant) {
        var _this24$platformUtil;

        return _this24.filterRestaurants(restaurant, _this24.isFromLocationSearchPage) || ((_this24$platformUtil = _this24.platformUtil) === null || _this24$platformUtil === void 0 ? void 0 : _this24$platformUtil.PLATFORM_TYPE) === PlatformType.APP;
      });
    }
  }, {
    key: "selectedLocationState",
    get: function get() {
      return this._selectedLocationState;
    }
  }, {
    key: "selectedLocationStateForPreferredFlow",
    get: function get() {
      return this._selectedLocationStateForPreferredFlow;
    }
  }, {
    key: "allRests",
    get: function get() {
      var _this$_restaurantSear2;

      var restaurants = {};
      var internationalCode = this.isFromLocationSearchPage || this.appShouldShowInternationalLocations ? i18next.t("label.locationsearch.i18nlist", {
        defaultValue: "International Locations"
      }) : null;
      this === null || this === void 0 ? void 0 : (_this$_restaurantSear2 = this._restaurantSearchResults) === null || _this$_restaurantSear2 === void 0 ? void 0 : _this$_restaurantSear2.forEach(function (item) {
        // Considering other countries as international locations
        var stateName = (item === null || item === void 0 ? void 0 : item.contactDetail.address.country) === "US" || (item === null || item === void 0 ? void 0 : item.contactDetail.address.country) === "USA" ? item === null || item === void 0 ? void 0 : item.contactDetail.address.stateName : internationalCode;

        if (stateName) {
          if (restaurants !== null && restaurants !== void 0 && restaurants[stateName]) {
            var _restaurants$stateNam;

            (_restaurants$stateNam = restaurants[stateName]) === null || _restaurants$stateNam === void 0 ? void 0 : _restaurants$stateNam.push(item);
          } else {
            restaurants[stateName] = [item];
          }
        }
      });
      return Object.keys(restaurants).sort(function (a, b) {
        // Normal sort with international being the last item in the list
        if (a === b) return 0;
        if (a === internationalCode) return 1;
        if (b === internationalCode) return -1;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }).map(function (key) {
        var _restaurants$key;

        return {
          state: key,
          restaurants: (_restaurants$key = restaurants[key]) === null || _restaurants$key === void 0 ? void 0 : _restaurants$key.sort(function compare(a, b) {
            if ((a === null || a === void 0 ? void 0 : a.restaurantName) < (b === null || b === void 0 ? void 0 : b.restaurantName)) {
              return -1;
            }

            if ((a === null || a === void 0 ? void 0 : a.restaurantName) > (b === null || b === void 0 ? void 0 : b.restaurantName)) {
              return 1;
            }

            return 0;
          })
        };
      });
    }
  }, {
    key: "allSortedLocations",
    get: function get() {
      return this.allRests.map(function (item) {
        return item.state;
      });
    }
  }, {
    key: "allSortedLocationsAllowedForPreferredLocation",
    get: function get() {
      var _this$allRests, _this$allRests$map$fi;

      return this === null || this === void 0 ? void 0 : (_this$allRests = this.allRests) === null || _this$allRests === void 0 ? void 0 : (_this$allRests$map$fi = _this$allRests.map(function (restaurantsWithState) {
        return {
          state: restaurantsWithState === null || restaurantsWithState === void 0 ? void 0 : restaurantsWithState.state,
          restaurants: restaurantsWithState === null || restaurantsWithState === void 0 ? void 0 : restaurantsWithState.restaurants.filter(function (restaurant) {
            return restaurant.features.allowPreferredLocation;
          })
        };
      }).filter(function (stateData) {
        return stateData.restaurants.length > 0;
      })) === null || _this$allRests$map$fi === void 0 ? void 0 : _this$allRests$map$fi.map(function (item) {
        return item.state;
      });
    }
  }, {
    key: "allSortedLocationWithoutKerrowlocations",
    get: function get() {
      var _this$allRests2, _this$allRests2$filte;

      if (this.escapeKerrowLocationsFilterForLocationDropdown) return this.allRests.map(function (item) {
        return item.state;
      });else return (_this$allRests2 = this.allRests) === null || _this$allRests2 === void 0 ? void 0 : (_this$allRests2$filte = _this$allRests2.filter(function (restaurantsWithState) {
        var _restaurantsWithState, _restaurantsWithState2;

        return !!(restaurantsWithState !== null && restaurantsWithState !== void 0 && (_restaurantsWithState = restaurantsWithState.restaurants) !== null && _restaurantsWithState !== void 0 && (_restaurantsWithState2 = _restaurantsWithState.filter(function (restaurant) {
          var _restaurant$features2;

          return !!(restaurant !== null && restaurant !== void 0 && (_restaurant$features2 = restaurant.features) !== null && _restaurant$features2 !== void 0 && _restaurant$features2.onlineTogoEnabled);
        })) !== null && _restaurantsWithState2 !== void 0 && _restaurantsWithState2.length);
      })) === null || _this$allRests2$filte === void 0 ? void 0 : _this$allRests2$filte.map(function (item) {
        return item.state;
      });
    }
  }, {
    key: "restaurantsByState",
    get: function get() {
      var selectedState = this._selectedLocationState;

      if (this.selectedLocationState === "all") {
        return this === null || this === void 0 ? void 0 : this.allRests;
      }

      return this.allRests.filter(function (item) {
        return item.state === selectedState;
      });
    }
  }, {
    key: "restaurantsByStateForPreferredLocationFlow",
    get: function get() {
      var _this$allRests3;

      var selectedStateForPreferredFlow = this._selectedLocationStateForPreferredFlow;
      var restaurantsAllowedForPrefferedFlow = this === null || this === void 0 ? void 0 : (_this$allRests3 = this.allRests) === null || _this$allRests3 === void 0 ? void 0 : _this$allRests3.map(function (restaurantsWithState) {
        return {
          state: restaurantsWithState === null || restaurantsWithState === void 0 ? void 0 : restaurantsWithState.state,
          restaurants: restaurantsWithState === null || restaurantsWithState === void 0 ? void 0 : restaurantsWithState.restaurants.filter(function (restaurant) {
            return restaurant.features.allowPreferredLocation;
          })
        };
      }).filter(function (stateData) {
        return stateData.restaurants.length > 0;
      });

      if (this.selectedLocationStateForPreferredFlow === "all") {
        return restaurantsAllowedForPrefferedFlow;
      }

      return restaurantsAllowedForPrefferedFlow.filter(function (item) {
        return item.state === selectedStateForPreferredFlow;
      });
    }
  }, {
    key: "shouldShowLocationSearchByState",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      if (((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.configs) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.locationSearchByState) === "true") {
        return true;
      }

      return false;
    }
  }, {
    key: "addressSuggestions",
    get: function get() {
      return this._addressSuggestions;
    }
  }, {
    key: "currentRestaurant",
    get: function get() {
      return this._restaurantDetail;
    }
  }, {
    key: "currentRestaurantId",
    get: function get() {
      var _this$_restaurantDeta12;

      return this === null || this === void 0 ? void 0 : (_this$_restaurantDeta12 = this._restaurantDetail) === null || _this$_restaurantDeta12 === void 0 ? void 0 : _this$_restaurantDeta12.atgRestaurantId;
    }
  }, {
    key: "currentOrderType",
    get: function get() {
      return this._currentOrderType;
    },
    set: function set(_currentOrderType) {
      var _this25 = this;

      if (typeof _currentOrderType === "undefined") return;
      runInAction(function () {
        _this25._currentOrderType = _currentOrderType;
      });
    }
  }, {
    key: "showRestaurantSearchModal",
    get: function get() {
      return this._showRestaurantSearchModal;
    },
    set: function set(_showRestaurantSearchModal) {
      var _this26 = this;

      runInAction(function () {
        _this26._showRestaurantSearchModal = _showRestaurantSearchModal;
      });
    }
  }, {
    key: "showTimeSidebar",
    get: function get() {
      return this._showTimeSidebar;
    },
    set: function set(_showTimeSidebar) {
      var _this27 = this;

      runInAction(function () {
        _this27._showTimeSidebar = _showTimeSidebar;
      });
    }
  }, {
    key: "showOrderSettingsConfirmationModal",
    get: function get() {
      return this._showOrderSettingsConfirmationModal;
    },
    set: function set(_showOrderSettingsConfirmationModal) {
      var _this28 = this;

      runInAction(function () {
        _this28._showOrderSettingsConfirmationModal = _showOrderSettingsConfirmationModal;
      });
    }
  }, {
    key: "locationSearchMode",
    set: function set(_mode) {
      var _this29 = this;

      runInAction(function () {
        _this29._locationSearchMode = _mode;
      });
    },
    get: function get() {
      return this._locationSearchMode;
    }
  }, {
    key: "locationSearchLabel",
    get: function get() {
      return this._locationSearchLabel;
    },
    set: function set(_locationSearchLabel) {
      var _this30 = this;

      runInAction(function () {
        _this30._locationSearchLabel = _locationSearchLabel;
      });
    }
  }, {
    key: "locationSearchString",
    get: function get() {
      return this._locationSearchString;
    },
    set: function set(_locationSearchString) {
      var _this31 = this;

      runInAction(function () {
        _this31._locationSearchMode = "ADDRESS_SUGGESTION";
        _this31._locationSearchString = _locationSearchString;
      });
    }
  }, {
    key: "locationSearchStringWithoutSearchMode",
    set: function set(_val) {
      var _this32 = this;

      runInAction(function () {
        _this32._locationSearchString = _val;
      });
    }
  }, {
    key: "isLocationSettingsVisible",
    get: function get() {
      return this._isLocationSettingVisible;
    }
  }, {
    key: "isDeliveryMessageVisible",
    get: function get() {
      return this._isDeliveryMessageVisible;
    }
  }, {
    key: "nearbyRestaurantsList",
    get: function get() {
      return nearbyRestaurants;
    }
  }, {
    key: "showMyLocations",
    get: function get() {
      return this._showMyLocations;
    }
  }, {
    key: "activeLocationListIndex",
    set: function set(index) {
      var _this33 = this;

      runInAction(function () {
        _this33._activeLocationListIndex = index;
      });
    },
    get: function get() {
      return this._activeLocationListIndex;
    }
  }, {
    key: "supportedOrderTypes",
    get: function get() {
      var conceptCode = DPServices.Config.getConceptCode();
      var availableOrderTypes = new BrandRules(conceptCode).availableOrderTypes();
      return availableOrderTypes; //TOO: make this brand specific.
    }
  }, {
    key: "isPickupOrderAvailable",
    get: function get() {
      return this.supportedOrderTypes.indexOf(ORDER_TYPE.TOGO_PICKUP) !== -1;
    }
  }, {
    key: "isDeliveryOrderAvailable",
    get: function get() {
      var _this$_appAttributes4;

      var envProps = getEnvProps();
      var DELIVERY_FLOW_DISABLED = envProps === null || envProps === void 0 ? void 0 : envProps.DELIVERY_FLOW_DISABLED;
      return DELIVERY_FLOW_DISABLED !== "true" && ((_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : _this$_appAttributes4.cateringDeliveryEnabled);
    }
  }, {
    key: "showLocationSettings",
    get: function get() {
      return this._showLocationSettings;
    }
  }, {
    key: "deliveryOrPickupLocationName",
    get: function get() {
      var sessionDetails = this._sessionDetails;
      if (!sessionDetails) return "";

      if (this.orderType === ORDER_TYPE.CATERING_DELIVERY) {
        var _sessionDetails$deliv;

        return sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv === void 0 ? void 0 : _sessionDetails$deliv.address1;
      } else if (this.orderType === ORDER_TYPE.TOGO_DELIVERY) {
        var _sessionDetails$deliv2;

        return sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv2 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv2 === void 0 ? void 0 : _sessionDetails$deliv2.address1;
      } else {
        var _this$currentRestaura6;

        return ((_this$currentRestaura6 = this.currentRestaurant) === null || _this$currentRestaura6 === void 0 ? void 0 : _this$currentRestaura6.restaurantName) || "";
      }
    }
  }, {
    key: "isTogoDeliveryOrder",
    get: function get() {
      return this.orderType === ORDER_TYPE.TOGO_DELIVERY;
    }
  }, {
    key: "isCateringDeliveryOrder",
    get: function get() {
      return this.orderType === ORDER_TYPE.CATERING_DELIVERY || this.orderType === ORDER_TYPE.CATERING_PICKUP;
    }
  }, {
    key: "deliveryRestaurantAddress",
    get: function get() {
      var currentRestaurant = this.currentRestaurant;
      if (!currentRestaurant) return "";

      if (this.isTogoDeliveryOrder) {
        var _this$currentRestaura7, _this$currentRestaura8, _this$currentRestaura9, _this$currentRestaura10, _this$currentRestaura11, _this$currentRestaura12, _this$currentRestaura13, _this$currentRestaura14, _this$currentRestaura15, _this$currentRestaura16;

        var address = [];

        if ((_this$currentRestaura7 = this.currentRestaurant) !== null && _this$currentRestaura7 !== void 0 && (_this$currentRestaura8 = _this$currentRestaura7.address) !== null && _this$currentRestaura8 !== void 0 && _this$currentRestaura8.address1) {
          var _currentRestaurant$ad;

          address.push(currentRestaurant === null || currentRestaurant === void 0 ? void 0 : (_currentRestaurant$ad = currentRestaurant.address) === null || _currentRestaurant$ad === void 0 ? void 0 : _currentRestaurant$ad.address1);
        }

        if ((_this$currentRestaura9 = this.currentRestaurant) !== null && _this$currentRestaura9 !== void 0 && (_this$currentRestaura10 = _this$currentRestaura9.address) !== null && _this$currentRestaura10 !== void 0 && _this$currentRestaura10.address2) {
          var _currentRestaurant$ad2;

          address.push(currentRestaurant === null || currentRestaurant === void 0 ? void 0 : (_currentRestaurant$ad2 = currentRestaurant.address) === null || _currentRestaurant$ad2 === void 0 ? void 0 : _currentRestaurant$ad2.address2);
        }

        if ((_this$currentRestaura11 = this.currentRestaurant) !== null && _this$currentRestaura11 !== void 0 && (_this$currentRestaura12 = _this$currentRestaura11.address) !== null && _this$currentRestaura12 !== void 0 && _this$currentRestaura12.city) {
          var _currentRestaurant$ad3;

          address.push(currentRestaurant === null || currentRestaurant === void 0 ? void 0 : (_currentRestaurant$ad3 = currentRestaurant.address) === null || _currentRestaurant$ad3 === void 0 ? void 0 : _currentRestaurant$ad3.city);
        }

        if ((_this$currentRestaura13 = this.currentRestaurant) !== null && _this$currentRestaura13 !== void 0 && (_this$currentRestaura14 = _this$currentRestaura13.address) !== null && _this$currentRestaura14 !== void 0 && _this$currentRestaura14.state) {
          var _currentRestaurant$ad4;

          address.push(currentRestaurant === null || currentRestaurant === void 0 ? void 0 : (_currentRestaurant$ad4 = currentRestaurant.address) === null || _currentRestaurant$ad4 === void 0 ? void 0 : _currentRestaurant$ad4.state);
        }

        if ((_this$currentRestaura15 = this.currentRestaurant) !== null && _this$currentRestaura15 !== void 0 && (_this$currentRestaura16 = _this$currentRestaura15.address) !== null && _this$currentRestaura16 !== void 0 && _this$currentRestaura16.zipCode) {
          var _currentRestaurant$ad5;

          address.push(currentRestaurant === null || currentRestaurant === void 0 ? void 0 : (_currentRestaurant$ad5 = currentRestaurant.address) === null || _currentRestaurant$ad5 === void 0 ? void 0 : _currentRestaurant$ad5.zipCode);
        }

        return address.join(", ");
      }

      return "";
    }
  }, {
    key: "deliveryOrPickupLocationAddress",
    get: function get() {
      var sessionDetails = this._sessionDetails;
      if (!sessionDetails) return "";

      if (this.orderType === ORDER_TYPE.CATERING_DELIVERY || this.orderType === ORDER_TYPE.TOGO_DELIVERY) {
        var _sessionDetails$deliv3, _sessionDetails$deliv5, _sessionDetails$deliv7, _sessionDetails$deliv9, _sessionDetails$deliv11, _sessionDetails$deliv13;

        var address = [];

        if (sessionDetails !== null && sessionDetails !== void 0 && (_sessionDetails$deliv3 = sessionDetails.deliveryGroup) !== null && _sessionDetails$deliv3 !== void 0 && _sessionDetails$deliv3.address1) {
          var _sessionDetails$deliv4;

          address.push(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv4 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv4 === void 0 ? void 0 : _sessionDetails$deliv4.address1);
        }

        if (sessionDetails !== null && sessionDetails !== void 0 && (_sessionDetails$deliv5 = sessionDetails.deliveryGroup) !== null && _sessionDetails$deliv5 !== void 0 && _sessionDetails$deliv5.address2) {
          var _sessionDetails$deliv6;

          address.push(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv6 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv6 === void 0 ? void 0 : _sessionDetails$deliv6.address2);
        }

        if (sessionDetails !== null && sessionDetails !== void 0 && (_sessionDetails$deliv7 = sessionDetails.deliveryGroup) !== null && _sessionDetails$deliv7 !== void 0 && _sessionDetails$deliv7.city) {
          var _sessionDetails$deliv8;

          address.push(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv8 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv8 === void 0 ? void 0 : _sessionDetails$deliv8.city);
        }

        if (sessionDetails !== null && sessionDetails !== void 0 && (_sessionDetails$deliv9 = sessionDetails.deliveryGroup) !== null && _sessionDetails$deliv9 !== void 0 && _sessionDetails$deliv9.state) {
          var _sessionDetails$deliv10;

          address.push(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv10 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv10 === void 0 ? void 0 : _sessionDetails$deliv10.state);
        }

        if (sessionDetails !== null && sessionDetails !== void 0 && (_sessionDetails$deliv11 = sessionDetails.deliveryGroup) !== null && _sessionDetails$deliv11 !== void 0 && _sessionDetails$deliv11.postalCode && this.isTogoDeliveryOrder) {
          var _sessionDetails$deliv12;

          address.push(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv12 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv12 === void 0 ? void 0 : _sessionDetails$deliv12.postalCode);
        }

        if (sessionDetails !== null && sessionDetails !== void 0 && (_sessionDetails$deliv13 = sessionDetails.deliveryGroup) !== null && _sessionDetails$deliv13 !== void 0 && _sessionDetails$deliv13.country) {
          var _sessionDetails$deliv14;

          address.push(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv14 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv14 === void 0 ? void 0 : _sessionDetails$deliv14.country);
        }

        return address.join(", ");
      }

      return "";
    }
  }, {
    key: "deliveryOrPickupTime",
    get: function get() {
      var _sessionDetails$deliv15, _sessionDetails$deliv16;

      var sessionDetails = this._sessionDetails;
      if (!sessionDetails) return "";
      return this.orderType === (ORDER_TYPE.CATERING_DELIVERY || ORDER_TYPE.TOGO_DELIVERY) ? _getFormattedDate(sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv15 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv15 === void 0 ? void 0 : (_sessionDetails$deliv16 = _sessionDetails$deliv15.deliveryServiceDateTime) === null || _sessionDetails$deliv16 === void 0 ? void 0 : _sessionDetails$deliv16.time) : "";
    }
  }, {
    key: "resturantDestUrl",
    get: function get() {
      try {
        var _this$currentRestaura17, _this$currentRestaura18, _this$currentRestaura19, _this$currentRestaura20, _this$currentRestaura21, _this$currentRestaura22, _this$currentRestaura23, _this$currentRestaura24;

        if (!this.currentRestaurant) return "";
        return constructRestaurantDetailsUrl({
          state: (_this$currentRestaura17 = this.currentRestaurant) === null || _this$currentRestaura17 === void 0 ? void 0 : (_this$currentRestaura18 = _this$currentRestaura17.contactDetail) === null || _this$currentRestaura18 === void 0 ? void 0 : (_this$currentRestaura19 = _this$currentRestaura18.address) === null || _this$currentRestaura19 === void 0 ? void 0 : _this$currentRestaura19.stateCode,
          city: (_this$currentRestaura20 = this.currentRestaurant) === null || _this$currentRestaura20 === void 0 ? void 0 : (_this$currentRestaura21 = _this$currentRestaura20.contactDetail) === null || _this$currentRestaura21 === void 0 ? void 0 : (_this$currentRestaura22 = _this$currentRestaura21.address) === null || _this$currentRestaura22 === void 0 ? void 0 : _this$currentRestaura22.city,
          name: (_this$currentRestaura23 = this.currentRestaurant) === null || _this$currentRestaura23 === void 0 ? void 0 : _this$currentRestaura23.restaurantName,
          id: (_this$currentRestaura24 = this.currentRestaurant) === null || _this$currentRestaura24 === void 0 ? void 0 : _this$currentRestaura24.restaurantNumber
        });
      } catch (e) {
        return "";
      }
    }
  }, {
    key: "deliverynumberofGuest",
    get: function get() {
      var _sessionDetails$deliv17;

      var sessionDetails = this._sessionDetails;
      return this._deliveryOrderPartySize || (sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$deliv17 = sessionDetails.deliveryGroup) === null || _sessionDetails$deliv17 === void 0 ? void 0 : _sessionDetails$deliv17.partySize) || 0;
    }
  }, {
    key: "alwaysShowOrderType",
    get: function get() {
      var conceptCode = DPServices.Config.getConceptCode();
      var alwaysShowOrderType = new BrandRules(conceptCode).alwaysShowOrderType();
      return alwaysShowOrderType;
    }
  }, {
    key: "filterTogo",
    get: function get() {
      return this._filterTogo;
    }
  }, {
    key: "isOrderSettingsReadOnly",
    get: function get() {
      return this.orderType === ORDER_TYPE.ORDER_AHEAD;
    }
  }, {
    key: "isDineInEnabled",
    get: function get() {
      return this.orderType === ORDER_TYPE.ORDER_AHEAD;
    }
  }, {
    key: "cateringDeliveryMinOrderAmount",
    get: function get() {
      var _this$_sessionDetails6;

      return (_this$_sessionDetails6 = this._sessionDetails) === null || _this$_sessionDetails6 === void 0 ? void 0 : _this$_sessionDetails6.cateringDeliveryMinOrderAmountThreshold;
    }
  }, {
    key: "checkoutShippingPriceTooltip",
    get: function get() {
      var _this$_appAttributes5, _this$_appAttributes6;

      return (_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : (_this$_appAttributes6 = _this$_appAttributes5.configs) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.checkout_shipping_price_tooltip;
    }
  }, {
    key: "isFromLocationSearchPage",
    get: function get() {
      return this._isFromLocationSearchPage;
    },
    set: function set(bool) {
      var _this34 = this;

      runInAction(function () {
        _this34._isFromLocationSearchPage = bool;
      });
    }
  }, {
    key: "locationSearchTab",
    get: function get() {
      return this._locationSearchTab;
    }
  }, {
    key: "nearbyRestaurantRefs",
    get: function get() {
      return this._nearbyRestaurantRefs;
    }
  }, {
    key: "initialDimensionOfWebMap",
    get: function get() {
      return this._initialDimensionOfWebMap;
    }
  }, {
    key: "openHoursDisplayOrder",
    get: function get() {
      return this._openHoursDisplayOrder;
    },
    set: function set(_val) {
      var _this35 = this;

      runInAction(function () {
        _this35._openHoursDisplayOrder = _val;
      });
    }
  }, {
    key: "isScrollEnableOnLocationPinClick",
    get: function get() {
      return this._isScrollEnableOnLocationPinClick;
    }
  }, {
    key: "showYouAreHere",
    get: function get() {
      return this._showYouAreHere;
    },
    set: function set(val) {
      var _this36 = this;

      runInAction(function () {
        _this36._showYouAreHere = val;
      });
    }
  }, {
    key: "showUserCurrentLocation",
    get: function get() {
      return this._showUserCurrentLocation;
    },
    set: function set(value) {
      var _this37 = this;

      runInAction(function () {
        _this37._showUserCurrentLocation = value;
      });
    }
  }, {
    key: "isPermanentlyClosed",
    get: function get() {
      var _this$_restaurantDeta13, _this$_restaurantDeta14;

      return !!((_this$_restaurantDeta13 = this._restaurantDetail) !== null && _this$_restaurantDeta13 !== void 0 && (_this$_restaurantDeta14 = _this$_restaurantDeta13.features) !== null && _this$_restaurantDeta14 !== void 0 && _this$_restaurantDeta14.isPermanentlyClosed);
    }
  }, {
    key: "appShouldShowInternationalLocations",
    get: function get() {
      return this._appShouldShowInternationalLocations;
    },
    set: function set(val) {
      var _this38 = this;

      runInAction(function () {
        _this38._appShouldShowInternationalLocations = val;
      });
    }
  }, {
    key: "escapeKerrowLocationsFilterForLocationDropdown",
    get: function get() {
      var _this$_appAttributes7;

      return new BrandRules((_this$_appAttributes7 = this._appAttributes) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.currentConceptCode).escapeKerrowLocationsFilterForLocationDropdown();
    }
  }]);

  return OrderSettingsModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_currentOrderType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return ORDER_TYPE.TOGO_PICKUP;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_showRestaurantSearchModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_showOrderSettingsConfirmationModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_showTimeSidebar", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_isLocationSettingVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isDeliveryMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_locationSearchString", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_locationSearchLabel", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_addressSuggestions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_restaurantSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_selectedLocationState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "all";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_selectedLocationStateForPreferredFlow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "all";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_locationSearchMode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "RESTAURANT";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_showMyLocations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_activeLocationListIndex", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_showLocationSettings", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_togoThresholdAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_restPhoneNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_showPickupConfirmModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_isLocationsListLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_isSearchResultsLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_confirmTimeLocationLoader", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_locationTimeConfirmed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_resturantSelctedForChange", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_deliveryToPickupConfirmationLoader", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_orderTypeValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_savedRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_mylocationLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_deliveryOrderPartySize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_pickupDatetimeselected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "_isMapVisibleOnMobileSearch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "_filterTogo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "_savedLocationSearchEntries", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "_isFromLocationSearchPage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "_locationSearchTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return WEB_LOCATION_SEARCH_TAB_NAMES.NEARBY;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "_nearbyRestaurantRefs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "_initialDimensionOfWebMap", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "_openHoursDisplayOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "_isScrollEnableOnLocationPinClick", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "_showYouAreHere", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "_showUserCurrentLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "_appShouldShowInternationalLocations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "locationSearchedTerm", [_dec, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "happyHourLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "happyHourLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "headerNavigation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "headerNavigation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickupDateTimeSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pickupDateTimeSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mylocationLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mylocationLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedLocationSearchEntries", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedLocationSearchEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchedLocationDetail", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchedLocationDetail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedResturants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedResturants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOrderTypeValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOrderTypeValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resturantSelectedForChangeNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resturantSelectedForChangeNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationTimeConfirmed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationTimeConfirmed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryToPickupConfirmationLoader", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryToPickupConfirmationLoader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmTimeLocationLoader", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "confirmTimeLocationLoader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPickupConfirmModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPickupConfirmModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSearchResultsLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSearchResultsLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsLocationsListLoading", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsLocationsListLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationsListLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationsListLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsMapVisibleOnMobileSearch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsMapVisibleOnMobileSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMapVisibleOnMobileSearch", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMapVisibleOnMobileSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togoThresholdAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "togoThresholdAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRestPhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRestPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resturantPhoneNumberWithCountryCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resturantPhoneNumberWithCountryCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restPhoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCartMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCartMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantSearchResults", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantSearchResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedLocationState", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedLocationState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedLocationStateForPreferredFlow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedLocationStateForPreferredFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allRests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allRests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSortedLocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSortedLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSortedLocationsAllowedForPreferredLocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSortedLocationsAllowedForPreferredLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSortedLocationWithoutKerrowlocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSortedLocationWithoutKerrowlocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantsByState", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantsByState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantsByStateForPreferredLocationFlow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantsByStateForPreferredLocationFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldShowLocationSearchByState", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldShowLocationSearchByState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addressSuggestions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addressSuggestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentRestaurant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentRestaurant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentRestaurantId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentRestaurantId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentOrderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentOrderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showRestaurantSearchModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showRestaurantSearchModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTimeSidebar", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTimeSidebar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showOrderSettingsConfirmationModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showOrderSettingsConfirmationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationSearchMode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationSearchMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationSearchLabel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationSearchLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationSearchString", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationSearchString"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationSettingsVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationSettingsVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nearbyRestaurantsList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nearbyRestaurantsList"), _class.prototype), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "confirmOrderSettings", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {// NOOP
    };
  }
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "cancelOrderSettingsConfirmation", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {// NOOP
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "setShowMyLocations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowMyLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showMyLocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showMyLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeLocationListIndex", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeLocationListIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supportedOrderTypes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "supportedOrderTypes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPickupOrderAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPickupOrderAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryOrderAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryOrderAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLocationSettings", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLocationSettings"), _class.prototype), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "setShowLocationSettings", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this39 = this;

    return function (show) {
      _this39._showLocationSettings = show;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "deliveryOrPickupLocationName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryOrPickupLocationName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTogoDeliveryOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTogoDeliveryOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCateringDeliveryOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCateringDeliveryOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryRestaurantAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryRestaurantAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryOrPickupLocationAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryOrPickupLocationAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryOrPickupTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryOrPickupTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resturantDestUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resturantDestUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliverynumberofGuest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliverynumberofGuest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alwaysShowOrderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alwaysShowOrderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterTogo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filterTogo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderSettingsReadOnly", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderSettingsReadOnly"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDineInEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDineInEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cateringDeliveryMinOrderAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cateringDeliveryMinOrderAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkoutShippingPriceTooltip", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkoutShippingPriceTooltip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFromLocationSearchPage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFromLocationSearchPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationSearchTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationSearchTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLocationSearchTab", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLocationSearchTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nearbyRestaurantRefs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nearbyRestaurantRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNearbyRestaurantRefs", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setNearbyRestaurantRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNearbyRestaurantRefsToEmpty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setNearbyRestaurantRefsToEmpty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initialDimensionOfWebMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "initialDimensionOfWebMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openHoursDisplayOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "openHoursDisplayOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isScrollEnableOnLocationPinClick", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isScrollEnableOnLocationPinClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showYouAreHere", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showYouAreHere"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showUserCurrentLocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showUserCurrentLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPermanentlyClosed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPermanentlyClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appShouldShowInternationalLocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appShouldShowInternationalLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "escapeKerrowLocationsFilterForLocationDropdown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "escapeKerrowLocationsFilterForLocationDropdown"), _class.prototype)), _class));
export { OrderSettingsModel as default };